import { render } from "./HospitalAppointmentRecordOverlay.vue?vue&type=template&id=639d8005&scoped=true&lang=pug"
import script from "./HospitalAppointmentRecordOverlay.vue?vue&type=script&lang=js"
export * from "./HospitalAppointmentRecordOverlay.vue?vue&type=script&lang=js"

import "./HospitalAppointmentRecordOverlay.vue?vue&type=style&index=0&id=639d8005&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d8005"]])

export default __exports__